module.exports = __webpack_public_path__ + "img/car_00052.f495a62a.jpg";